const LOG_UI_HARDWARE_REVISION_OVERRIDES: Readonly<Record<number, number>> = {
  210: 211,
};

export function resolveLogUiHardwareRevision(hardwareRevision: number): number {
  return (
    LOG_UI_HARDWARE_REVISION_OVERRIDES[hardwareRevision] ?? hardwareRevision
  );
}
